import { createGlobalStyle } from 'styled-components';
import { GlobalStylesProps } from './scrollLock.types';

export const GlobalStyles = createGlobalStyle`
  ${(props: GlobalStylesProps) => !props.isOverscrollBehaviorSupported && props.elementIsDocumentBody && `
    html {
      @supports(height: constant(safe-area-inset-bottom))
        --safe-area-inset-bottom: constant(safe-area-inset-bottom, 0);
        height: calc(100vh - var(--safe-area-inset-bottom));
      }

      @supports(height: env(safe-area-inset-bottom))
          --safe-area-inset-bottom: env(safe-area-inset-bottom, 0);
          height: calc(100vh - var(--safe-area-inset-bottom));
      }
    }
  `}
  .${(props: GlobalStylesProps) => props.class} {
    overflow: hidden;
    touch-action: none;
    overscroll-behavior: none;
    ${(props: GlobalStylesProps) => !props.isOverscrollBehaviorSupported && `
      position: fixed;
      top: ${(props.top ?? 0) * -1}px;
      bottom: 0;
      right: 0;
      left: ${(props.left ?? 0) * -1}px;
    `}
  }
`;
